export const CHECK_HIDE_CUST_NUM = "CHECK_HIDE_CUST_NUM";
export const HIDE_CUST_NUM = "HIDE_CUST_NUM";
export const SHOW_INVOICE_AMOUNT_FIELD = "SHOW_INVOICE_AMOUNT_FIELD";
export const STORE_CUSTOMER_FIELDS = "STORE_CUSTOMER_FIELDS";


export const checkHideCustNumCallComplete = () => ({
	type: CHECK_HIDE_CUST_NUM
});

export const setHideCustomerNum = (data) => ({
    type: HIDE_CUST_NUM,
    payload: data
});

export const checkShowInvoiceAmountField = data => ({
	type: SHOW_INVOICE_AMOUNT_FIELD,
    payload: data
});

export const storeCustomerFields = data => ({
	type: STORE_CUSTOMER_FIELDS,
    payload: data
});